import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link, Icon, Text } from '@tesla/design-system-react';
import { iconChevronSmall270 } from '@tesla/design-system-icons';
import styles from './BackLink.module.css.js';

var BackLink = function BackLink(props) {
  var show = props.show,
    t = props.t;
  var className = classnames(styles['tw-react--aos--back-link'], props.className);
  var links =
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  React.createElement(Link, {
    className: className,
    variant: "secondary",
    onClick: function onClick() {
      return window.history.back();
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    data: iconChevronSmall270,
    inline: true
  }), /*#__PURE__*/React.createElement(Text, {
    is: "span",
    contrast: "low",
    weight: "medium"
  }, t.back));
  return show ? links : null;
};
BackLink.propTypes = {
  show: PropTypes.bool,
  t: PropTypes.func.isRequired
};
BackLink.defaultProps = {
  show: false
};

export { BackLink as default };
